// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Editing div.editing-body {
    padding: 0.25em;
    position: relative;
    min-height: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
}

#Editing .editing-minimize-maximize {
    margin-left: 1em;
    cursor: pointer;
    padding: 0.25em;
}

#Editing div.editing-body > div:not(:last-child) {
    margin-bottom: 0.25em;
}

#Editing div.editing-body > div.editing-layer-selection,
#Editing div.editing-body > div.editing-feature-selection,
#Editing div.editing-body > div.ButtonBar {
    flex: 0 0 auto;
}

#Editing div.editing-body > div.AttributeForm {
    margin-top: 0.25em;
    padding-top: 0.5em;
    border-top: 1px solid var(--border-color);
    flex: 1 1 auto;
    overflow: hidden;
}

#Editing select.editing-layer-select,
#Editing select.editing-feature-select {
    width: 100%;
}

#Editing select.editing-layer-select:disabled,
#Editing select.editing-feature-select:disabled {
    cursor: not-allowed;
}

.editing-clone-dialog {
    display: flex;
    flex-direction: column;
    gap: 0.25em;
}

.editing-clone-header {
    font-weight: bold;
    margin-bottom: 0.25em;
}

.editing-clone-table {
    margin-top: calc(-0.25em - 1px);
    background: var(--list-bg-color);
    border: 1px solid var(--border-color);
    width: 100%;
    table-layout: fixed;
}

.editing-clone-table td {
    padding: 0.125em 0.25em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 50%;
}

.editing-clone-attribute {
    display: flex;
    align-items: center;
    gap: 0.5em;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./qwc2/plugins/style/Editing.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;IACzC,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,qCAAqC;IACrC,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,eAAe;AACnB","sourcesContent":["#Editing div.editing-body {\n    padding: 0.25em;\n    position: relative;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n#Editing .editing-minimize-maximize {\n    margin-left: 1em;\n    cursor: pointer;\n    padding: 0.25em;\n}\n\n#Editing div.editing-body > div:not(:last-child) {\n    margin-bottom: 0.25em;\n}\n\n#Editing div.editing-body > div.editing-layer-selection,\n#Editing div.editing-body > div.editing-feature-selection,\n#Editing div.editing-body > div.ButtonBar {\n    flex: 0 0 auto;\n}\n\n#Editing div.editing-body > div.AttributeForm {\n    margin-top: 0.25em;\n    padding-top: 0.5em;\n    border-top: 1px solid var(--border-color);\n    flex: 1 1 auto;\n    overflow: hidden;\n}\n\n#Editing select.editing-layer-select,\n#Editing select.editing-feature-select {\n    width: 100%;\n}\n\n#Editing select.editing-layer-select:disabled,\n#Editing select.editing-feature-select:disabled {\n    cursor: not-allowed;\n}\n\n.editing-clone-dialog {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25em;\n}\n\n.editing-clone-header {\n    font-weight: bold;\n    margin-bottom: 0.25em;\n}\n\n.editing-clone-table {\n    margin-top: calc(-0.25em - 1px);\n    background: var(--list-bg-color);\n    border: 1px solid var(--border-color);\n    width: 100%;\n    table-layout: fixed;\n}\n\n.editing-clone-table td {\n    padding: 0.125em 0.25em;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: 50%;\n}\n\n.editing-clone-attribute {\n    display: flex;\n    align-items: center;\n    gap: 0.5em;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
